module.exports = __webpack_public_path__ + "img/logo-finalist.2b765ad6.jpg";